module.exports = __webpack_public_path__ + "img/show1.06001928.jpg";